// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const AdminOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [updateStatus, setUpdateStatus] = useState("");

//   // Fetch orders
//   const fetchOrders = async () => {
//     try {
//       const response = await axios.get("/api/orders");
//       setOrders(response.data);
//       setLoading(false);
//     } catch (err) {
//       setError("Failed to fetch orders. Please try again later.");
//       setLoading(false);
//     }
//   };

//   // Update delivery status
//   const updateDeliveryStatus = async (orderId, status) => {
//     try {
//       const response = await axios.put(
//         `/api/orders/${orderId}/delivery-status`,
//         { deliveryStatus: status }
//       );
//       setUpdateStatus(`Order ${orderId} updated to ${status}.`);
//       // Update the local state
//       setOrders((prevOrders) =>
//         prevOrders.map((order) =>
//           order.orderId === orderId ? { ...order, deliveryStatus: status } : order
//         )
//       );
//     } catch (err) {
//       setError(`Failed to update order ${orderId}.`);
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   if (loading) return <div>Loading orders...</div>;
//   if (error) return <div>{error}</div>;

//   return (
//     <div>
//       <h1>Admin Orders</h1>
//       {updateStatus && <p style={{ color: "green" }}>{updateStatus}</td>}
//       {orders.map((order) => (
//         <div key={order.orderId} style={{ border: "1px solid #ddd", padding: "10px", margin: "10px 0" }}>
//           <h3>Order ID: {order.orderId}</h3>
//           <td><strong>Customer:</strong> {order.customerDetails.firstName} {order.customerDetails.lastName}</td>
//           <td><strong>Total Amount:</strong> ₹{order.paymentDetails.totalAmount}</td>
//           <td><strong>Delivery Status:</strong> {order.deliveryStatus}</td>
//           <select
//             value={order.deliveryStatus}
//             onChange={(e) => updateDeliveryStatus(order.orderId, e.target.value)}
//           >
//             <option value="pending">Pending</option>
//             <option value="shipped">Shipped</option>
//             <option value="delivered">Delivered</option>
//             <option value="cancelled">Cancelled</option>
//           </select>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default AdminOrders;

// import React, { useState, useEffect } from "react";
// import AdminHome from "./AdminHome";
// import axios from "axios";


// const AdminOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // Fetch orders
//   const fetchOrders = async () => {
//     try {
//       const response = await axios.get("/api/orders");
//       setOrders(response.data.map((order) => ({ ...order, notification: null, updatedAt: new Date() })));
//       setLoading(false);
//     } catch (err) {
//       setError("Failed to fetch orders. Please try again later.");
//       setLoading(false);
//     }
//   };

//   // Update delivery status
//   const updateDeliveryStatus = async (orderId, status) => {
//     try {
//       const response = await axios.put(`/api/orders/${orderId}/delivery-status`, {
//         deliveryStatus: status,
//       });
//       const updatedOrder = response.data;

//       setOrders((prevOrders) =>
//         prevOrders.map((order) =>
//           order.orderId === orderId
//             ? {
//                 ...order,
//                 deliveryStatus: status,
//                 notification: `Updated to '${status}' on ${new Date().toLocaleString()}`,
//                 updatedAt: new Date(),
//               }
//             : order
//         )
//       );
//     } catch (err) {
//       setOrders((prevOrders) =>
//         prevOrders.map((order) =>
//           order.orderId === orderId
//             ? { ...order, notification: "Failed to update. Please try again.", updatedAt: new Date() }
//             : order
//         )
//       );
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   // Internal CSS for styling
//   // const styles = {
//   //   container: {
//   //     fontFamily: "Arial, sans-serif",
//   //     padding: "20px",
//   //     maxWidth: "900px",
//   //     margin: "auto",
//   //   },
//   //   orderCard: {
//   //     border: "1px solid #ddd",
//   //     borderRadius: "5px",
//   //     padding: "15px",
//   //     margin: "10px 0",
//   //     backgroundColor: "#f9f9f9",
//   //     boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
//   //     position: "relative",
//   //   },
//   //   title: {
//   //     color: "#333",
//   //   },
//   //   select: {
//   //     marginTop: "10px",
//   //     padding: "5px",
//   //     border: "1px solid #ccc",
//   //     borderRadius: "5px",
//   //     width: "100%",
//   //     maxWidth: "300px",
//   //   },
//   //   notification: {
//   //     marginTop: "10px",
//   //     padding: "10px",
//   //     borderRadius: "5px",
//   //     fontSize: "14px",
//   //     color: "#fff",
//   //   },
//   //   success: {
//   //     backgroundColor: "#28a745",
//   //   },
//   //   error: {
//   //     backgroundColor: "#dc3545",
//   //   },
//   //   timestamp: {
//   //     fontSize: "12px",
//   //     color: "#6c757d",
//   //     marginTop: "5px",
//   //   },
//   //   errorText: {
//   //     backgroundColor: "#f8d7da",
//   //     color: "#721c24",
//   //     padding: "10px",
//   //     marginBottom: "15px",
//   //     borderRadius: "5px",
//   //     fontSize: "14px",
//   //     border: "1px solid #f5c6cb",
//   //   },
//   // };

//   // if (loading) return <div style={styles.container}>Loading orders...</div>;
//   // if (error) return <div style={{ ...styles.container, ...styles.errorText }}>{error}</div>;

//   return (
//     <>
//     <div className="tf-page-title">
//             <div className="container-full">
//                 <div className="heading text-center">Admin Orders</div>
//             </div>
//         </div>
//         <section className="flat-spacing-11">
//             <div className="container">
//                 <div className="row">
//                     <div className="col-lg-3">
//                         <div className="wrap-sidebar-account">
//                             <ul className="my-account-nav">
//                                 {/* <li><span className="my-account-nav-item ">Home</span></li> */}
//                                 <li><a href="/adminallproducts" className="my-account-nav-item">All Products</a></li>
//                                 <li><a href="/adminaddproduct" className="my-account-nav-item">Add Products</a></li>
//                                 <li><a href="/adminorders" className="my-account-nav-item active">Orders</a></li>
//                                 <li><a href="/admincategory" className="my-account-nav-item">Add Category</a></li>
//                                 <li><a href="/adminstyle" className="my-account-nav-item">Add Style Type</a></li>
//                                 <li><a href="/adminrentform" className="my-account-nav-item">Add SubModules</a></li>
//                                 {/* <li><a href="/AdminOrders" className="my-account-nav-item">Orders</a></li> */}
//                                 <li><a href="/StockManagement" className="my-account-nav-item">StockManagement</a></li>
//                                 {/* <li><a href="/wishlist" className="my-account-nav-item">Wishlist</a></li> */}

//                             </ul>
//                         </div>
//                     </div>
//                     <div className="col-lg-9">
//                     <ul className="tf-table-page-cart">

//                     {orders.map((order) => (
//         <li key={order.orderId} >
//           <th>Order ID: {order.orderId}</th>
//           <td>
//             <strong>Customer:</strong> {order.customerDetails.firstName} {order.customerDetails.lastName}
//           </td>
//           <td>
//             <strong>Customer ID:</strong> {order.customerId}
//           </td>
//           <td>
//             <strong>Total Amount:</strong> ₹{order.paymentDetails.totalAmount}
//           </td>
//           <td>
//             <strong>Delivery Status:</strong> {order.deliveryStatus}
//           </td>
//           <select
//             // style={styles.select}
//             value={order.deliveryStatus}
//             onChange={(e) => updateDeliveryStatus(order.orderId, e.target.value)}
//           >
//             <option value="pending">Pending</option>
//             <option value="shipped">Shipped</option>
//             <option value="delivered">Delivered</option>
//             <option value="cancelled">Cancelled</option>
//           </select>
//           {order.notification && (
//             <div
//               // style={{
//               //   ...styles.notification,
//               //   ...(order.notification.startsWith("Updated") ? styles.success : styles.error),
//               // }}
//             >
//               {order.notification}
//               {order.updatedAt && (
//                 <div >
//                   Last Updated: {new Date(order.updatedAt).toLocaleString()}
//                 </div>
//               )}
//             </div>
//           )}
//          <div style={{height:'1px', width:'100%',backgroundColor:'black', marginTop:'10px'}}></div>
//         </li>
//       ))} 
//                     </ul></div>
//                 </div>
//             </div>

//             <div className="btn-sidebar-account">
//                 <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
//                     <i className="icon icon-sidebar-2"></i>
//                 </button>
//             </div>

//             <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
//                 <div className="canvas-wrapper">
//                     <header className="canvas-header">
//                         <span className="title">SIDEBAR ACCOUNT</span>
//                         <AdminHome />
//                         <span className="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
//                     </header>
//                     <div className="canvas-body sidebar-mobile-append"> </div>
//                 </div>
//             </div>
//         </section>

//     {/* <div style={styles.container}>
//       <h1 style={styles.title}>Admin Orders</h1>

//     </div> */}

//     </>
//   );
// };

// export default AdminOrders;


// import React, { useState, useEffect } from "react";
// import AdminHome from "./AdminHome";
// import axios from "axios";
// import { IoCloseSharp } from "react-icons/io5";
// const AdminOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);

//   // Fetch orders
//   const fetchOrders = async () => {
//     try {
//       const response = await axios.get("/api/orders");
//       setOrders(response.data.map((order) => ({ ...order, notification: null, updatedAt: new Date() })));
//       setLoading(false);
//     } catch (err) {
//       setError("Failed to fetch orders. Please try again later.");
//       setLoading(false);
//     }
//   };

//   // Update delivery status
//   const updateDeliveryStatus = async (orderId, status) => {
//     try {
//       const response = await axios.put(`/api/orders/${orderId}/delivery-status`, {
//         deliveryStatus: status,
//       });

//       setOrders((prevOrders) =>
//         prevOrders.map((order) =>
//           order.orderId === orderId
//             ? {
//                 ...order,
//                 deliveryStatus: status,
//                 notification: `Updated to '${status}' on ${new Date().toLocaleString()}`,
//                 updatedAt: new Date(),
//               }
//             : order
//         )
//       );
//     } catch (err) {
//       setOrders((prevOrders) =>
//         prevOrders.map((order) =>
//           order.orderId === orderId
//             ? { ...order, notification: "Failed to update. Please try again.", updatedAt: new Date() }
//             : order
//         )
//       );
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   // Search functionality
//   const filteredOrders = orders.filter((order) => {
//     const searchStr = searchTerm.toLowerCase();
//     return (
//       order.orderId.toString().toLowerCase().includes(searchStr) ||
//       order.customerDetails.firstName.toLowerCase().includes(searchStr) ||
//       order.customerDetails.lastName.toLowerCase().includes(searchStr) ||
//       order.customerId.toString().toLowerCase().includes(searchStr) ||
//       order.paymentDetails.totalAmount.toString().includes(searchStr) ||
//       order.deliveryStatus.toLowerCase().includes(searchStr)
//     );
//   });

//   // Pagination calculations
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

//   // Page change handler
//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   return (
//     <>
//       <div className="tf-page-title">
//         <div className="container-full">
//           <div className="heading text-center">Admin Orders</div>
//         </div>
//       </div>
//       <section className="flat-spacing-11">
//         <div className="container">
//           <div className="row">
//             {/* <div className="col-lg-3">
//               <div className="wrap-sidebar-account">
//                 <ul className="my-account-nav">
//                   <li><a href="/adminallproducts" className="my-account-nav-item">All Products</a></li>
//                   <li><a href="/adminaddproduct" className="my-account-nav-item">Add Products</a></li>
//                   <li><a href="/adminorders" className="my-account-nav-item active">Orders</a></li>
//                   <li><a href="/admincategory" className="my-account-nav-item">Add Category</a></li>
//                   <li><a href="/adminstyle" className="my-account-nav-item">Add Style Type</a></li>
//                   <li><a href="/adminrentform" className="my-account-nav-item">Add SubModules</a></li>
//                   <li><a href="/StockManagement" className="my-account-nav-item">StockManagement</a></li>
//                 </ul>
//               </div>
//             </div> */}
//             <AdminHome/>
//             <div className="col-lg-9">
//               {/* Search and Items per page controls */}
//               <div className="mb-4 flex items-center justify-between">
//                 <div className="flex items-center gap-4">
//                   <input
//                     type="text"
//                     placeholder="Search orders..."
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     className="p-2 border rounded"
//                   />
//                   <select
//                     value={itemsPerPage}
//                     onChange={(e) => setItemsPerPage(Number(e.target.value))}
//                     className="p-2 border rounded"
//                   >
//                     <option value={5}>5 per page</option>
//                     <option value={10}>10 per page</option>
//                     <option value={20}>20 per page</option>
//                     <option value={50}>50 per page</option>
//                   </select>
//                 </div>
//               </div>

//               <ul className="tf-table-page-cart">
//                 {currentItems.map((order) => (
//                   <li key={order.orderId}>
//                     <th>Order ID: {order.orderId}</th>
//                     <td>
//                       <strong>Customer:</strong> {order.customerDetails.firstName} {order.customerDetails.lastName}
//                     </td>
//                     <td>
//                       <strong>Customer ID:</strong> {order.customerId}
//                     </td>
//                     <td>
//                       <strong>Total Amount:</strong> ₹{order.paymentDetails.totalAmount}
//                     </td>
//                     <td>
//                       <strong>Delivery Status:</strong> {order.deliveryStatus}
//                     </td>
//                     <select
//                       value={order.deliveryStatus}
//                       onChange={(e) => updateDeliveryStatus(order.orderId, e.target.value)}
//                       className="p-2 border rounded"
//                     >
//                       <option value="pending">Pending</option>
//                       <option value="shipped">Shipped</option>
//                       <option value="delivered">Delivered</option>
//                       <option value="cancelled">Cancelled</option>
//                     </select>
//                     {order.notification && (
//                       <div className={`p-2 mt-2 rounded ${
//                         order.notification.startsWith("Updated") ? "bg-green-100" : "bg-red-100"
//                       }`}>
//                         {order.notification}
//                         {order.updatedAt && (
//                           <div className="text-sm text-gray-600">
//                             Last Updated: {new Date(order.updatedAt).toLocaleString()}
//                           </div>
//                         )}
//                       </div>
//                     )}
//                     <div style={{height:'1px', width:'100%', backgroundColor:'black', marginTop:'10px'}}></div>
//                   </li>
//                 ))}
//               </ul>

//               {/* Pagination controls */}
//               <div className="mt-4 flex justify-center gap-2">
//                 <button
//                   onClick={() => handlePageChange(currentPage - 1)}
//                   disabled={currentPage === 1}
//                   className="px-4 py-2 border rounded disabled:opacity-50"
//                 >
//                   Previous
//                 </button>
//                 {[...Array(totalPages)].map((_, index) => (
//                   <button
//                     key={index + 1}
//                     onClick={() => handlePageChange(index + 1)}
//                     className={`px-4 py-2 border rounded ${
//                       currentPage === index + 1 ? "bg-blue-500 text-white" : ""
//                     }`}
//                   >
//                     {index + 1}
//                   </button>
//                 ))}
//                 <button
//                   onClick={() => handlePageChange(currentPage + 1)}
//                   disabled={currentPage === totalPages}
//                   className="px-4 py-2 border rounded disabled:opacity-50"
//                 >
//                   Next
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
// {/* 
//         <div className="btn-sidebar-account">
//           <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
//             <i className="icon icon-sidebar-2"></i>
//           </button>
//         </div> */}

//         <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
//           <div className="canvas-wrapper">
//             <header className="canvas-header">
//               <span className="title">SIDEBAR ACCOUNT</span>
//               {/* <AdminHome /> */}
//               <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
//             </header>
//             <div className="canvas-body sidebar-mobile-append"></div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default AdminOrders;
// import React, { useState, useEffect } from "react";
// import AdminHome from "./AdminHome";
// import axios from "axios";
// import { IoCloseSharp } from "react-icons/io5";
// import "./Adminorder.css"; // We'll create this CSS file next

// const AdminOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [sortOrder, setSortOrder] = useState("newest");
//   const [filters, setFilters] = useState({
//     orderId: "",
//     phone: "",
//     customerName: "",
//   });

//   const fetchOrders = async () => {
//     try {
//       const response = await axios.get("/api/orders");
//       const sortedOrders = response.data.map((order) => ({
//         ...order,
//         notification: null,
//         updatedAt: new Date(),
//       }));
//       setOrders(sortedOrders);
//       setLoading(false);
//     } catch (err) {
//       setError("Failed to fetch orders. Please try again later.");
//       setLoading(false);
//     }
//   };

//   const updateDeliveryStatus = async (orderId, status) => {
//     try {
//       await axios.put(`/api/orders/${orderId}/delivery-status`, {
//         deliveryStatus: status,
//       });

//       setOrders((prevOrders) =>
//         prevOrders.map((order) =>
//           order.orderId === orderId
//             ? {
//                 ...order,
//                 deliveryStatus: status,
//                 notification: `Updated to '${status}' on ${new Date().toLocaleString()}`,
//                 updatedAt: new Date(),
//               }
//             : order
//         )
//       );
//     } catch (err) {
//       setOrders((prevOrders) =>
//         prevOrders.map((order) =>
//           order.orderId === orderId
//             ? { ...order, notification: "Failed to update. Please try again.", updatedAt: new Date() }
//             : order
//         )
//       );
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   const filteredOrders = orders.filter((order) => {
//     const orderIdMatch = order.orderId.toLowerCase().includes(filters.orderId.toLowerCase());
//     const phoneMatch = order.customerDetails.mobile.includes(filters.phone);
//     const customerNameMatch = 
//       `${order.customerDetails.firstName} ${order.customerDetails.lastName}`
//         .toLowerCase()
//         .includes(filters.customerName.toLowerCase());

//     return (
//       (filters.orderId === "" || orderIdMatch) &&
//       (filters.phone === "" || phoneMatch) &&
//       (filters.customerName === "" || customerNameMatch)
//     );
//   });

//   const sortedOrders = [...filteredOrders].sort((a, b) => {
//     const dateA = new Date(a.createdAt);
//     const dateB = new Date(b.createdAt);
//     return sortOrder === "newest" ? dateB - dateA : dateA - dateB;
//   });

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = sortedOrders.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(sortedOrders.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//     setCurrentPage(1); // Reset to first page when filters change
//   };

//   const getStatusClassName = (status) => {
//     switch (status.toLowerCase()) {
//       case 'pending': return 'status-pending';
//       case 'shipped': return 'status-shipped';
//       case 'delivered': return 'status-delivered';
//       case 'cancelled': return 'status-cancelled';
//       default: return '';
//     }
//   };

//   return (
//     <div className="admin-orders">
//       <div className="admin-orders-header">
//         <h1>Order Management</h1>
//       </div>

//       <div className="admin-orders-container">
//         <AdminHome />

//         <div className="orders-content">
//           <div className="filters-section">
//             <div className="search-group">
//               <input
//                 type="text"
//                 name="orderId"
//                 placeholder="Search by Order ID"
//                 value={filters.orderId}
//                 onChange={handleFilterChange}
//                 className="search-input"
//               />
//               <input
//                 type="text"
//                 name="phone"
//                 placeholder="Search by Phone"
//                 value={filters.phone}
//                 onChange={handleFilterChange}
//                 className="search-input"
//               />
//               <input
//                 type="text"
//                 name="customerName"
//                 placeholder="Search by Customer Name"
//                 value={filters.customerName}
//                 onChange={handleFilterChange}
//                 className="search-input"
//               />
//             </div>

//             <div className="controls-group">
//               <select
//                 value={sortOrder}
//                 onChange={(e) => setSortOrder(e.target.value)}
//                 className="sort-select"
//               >
//                 <option value="newest">Newest First</option>
//                 <option value="oldest">Oldest First</option>
//               </select>

//               <select
//                 value={itemsPerPage}
//                 onChange={(e) => setItemsPerPage(Number(e.target.value))}
//                 className="items-select"
//               >
//                 <option value={5}>5 per page</option>
//                 <option value={10}>10 per page</option>
//                 <option value={20}>20 per page</option>
//                 <option value={50}>50 per page</option>
//               </select>
//             </div>
//           </div>

//           {loading ? (
//             <div className="loading-spinner">Loading orders...</div>
//           ) : error ? (
//             <div className="error-message">{error}</div>
//           ) : (
//             <div className="orders-list">
//               {currentItems.map((order) => (
//                 <div key={order.orderId} className="order-card">
//                   <div className="order-header">
//                     <div className="order-id">Order #{order.orderId}</div>
//                     <div className={`order-status ${getStatusClassName(order.deliveryStatus)}`}>
//                       {order.deliveryStatus}
//                     </div>
//                   </div>

//                   <div className="order-content">
//                     <div className="order-details">
//                       <div className="customer-info">
//                         <h3>Customer Details</h3>
//                         <p><strong>Name:</strong> {order.customerDetails.firstName} {order.customerDetails.lastName}</p>
//                         <p><strong>Phone:</strong> {order.customerDetails.mobile}</p>
//                         <p><strong>Email:</strong> {order.customerDetails.email}</p>
//                       </div>

//                       <div className="payment-info">
//                         <h3>Payment Information</h3>
//                         <p><strong>Total Amount:</strong> ₹{order.paymentDetails.totalAmount}</p>
//                         <p><strong>Product Price:</strong> ₹{order.paymentDetails.productPrice}</p>
//                         <p><strong>Security Deposit:</strong> ₹{order.paymentDetails.securityDeposit}</p>
//                       </div>

//                       <div className="status-control">
//                         <h3>Update Status</h3>
//                         <select
//                           value={order.deliveryStatus}
//                           onChange={(e) => updateDeliveryStatus(order.orderId, e.target.value)}
//                           className="status-select"
//                         >
//                           <option value="pending">Pending</option>
//                           <option value="shipped">Shipped</option>
//                           <option value="delivered">Delivered</option>
//                           <option value="cancelled">Cancelled</option>
//                         </select>
//                       </div>
//                     </div>

//                     <div className="products-section">
//                       <h3>Products</h3>
//                       <div className="products-grid">
//                         {order.products.map((product, index) => (
//                           <div key={index} className="product-card">
//                             <div className="product-image">
//                               <img
//                                 src={`${product.images}`}
//                                 alt="Product"
//                               />
//                             </div>
//                             <div className="product-info">
//                               <p><strong>ID:</strong> {product.productId}</p>
//                               <p><strong>Size:</strong> {product.sizeId}</p>
//                               <p><strong>Price:</strong> ₹{product.price}</p>
//                               <p><strong>Quantity:</strong> {product.quantity}</p>
//                               <p><strong>Duration:</strong> {product.duration} days</p>
//                               <p><strong>Delivery:</strong> {new Date(product.deliveryDate).toLocaleDateString()}</p>
//                               <p><strong>Return:</strong> {new Date(product.returnDate).toLocaleDateString()}</p>
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>

//                   {order.notification && (
//                     <div className={`notification ${order.notification.startsWith("Updated") ? "success" : "error"}`}>
//                       {order.notification}
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           )}

//           <div className="pagination">
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="pagination-button"
//             >
//               Previous
//             </button>

//             <div className="page-numbers">
//               {[...Array(totalPages)].map((_, index) => (
//                 <button
//                   key={index + 1}
//                   onClick={() => handlePageChange(index + 1)}
//                   className={`page-number ${currentPage === index + 1 ? 'active' : ''}`}
//                 >
//                   {index + 1}
//                 </button>
//               ))}
//             </div>

//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="pagination-button"
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminOrders;
import React, { useState, useEffect } from "react";
import AdminHome from "./AdminHome";
import { IoCloseSharp } from "react-icons/io5";
import { BsMenuButtonWideFill } from "react-icons/bs";
import axios from "axios";
import "./Adminorder.css";

const OrderProductCard = ({ product }) => (
  <div className="detailed-product-card">
    <div className="product-image-container">
      <img
        src={`${product.images}`}
        alt="Product"
        className="product-image"
      />
      <div className="price-tag">₹{product.price}</div>
    </div>
    <div className="product-details-grid">
      <div className="detail-row">
        <span className="detail-label">Size:</span>
        <span className="detail-value">{product.sizeId}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Quantity:</span>
        <span className="detail-value">{product.quantity}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Duration:</span>
        <span className="detail-value">{product.duration} days</span>
      </div>
      <div className="rental-dates">
        <div className="date-box">
          <span className="date-label">Delivery Date</span>
          <span className="date-value">
            {product.deliveryDate}
          </span>
        </div>
        <div className="date-divider">→</div>
        <div className="date-box">
          <span className="date-label">Return Date</span>
          <span className="date-value">
           {product.returnDate}
            
          </span>
        </div>
      </div>
    </div>
  </div>
);

const OrderCard = ({ order, updateDeliveryStatus }) => (
  <div className="order-card">
    <div className="order-header">
      <div className="order-header-left">
        <div className="order-id">Order #{order.orderId}</div>
        <div className="order-date">
          {new Date(order.orderDate).toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })}
          {/* {order.orderDate} */}
          {/* {new Date(order.orderDate).toLocaleString('en-US', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })} */}

        </div>
      </div>
      <div className="order-header-right">
        <div className="total-amount">₹{order.paymentDetails.totalAmount}</div>
        <select
          value={order.deliveryStatus}
          onChange={(e) => updateDeliveryStatus(order.orderId, e.target.value)}
          className={`status-select ${order.deliveryStatus.toLowerCase()}`}
        >
          <option value="pending">Pending</option>
          <option value="shipped">Shipped</option>
          <option value="delivered">Delivered</option>
          <option value="cancelled">Cancelled</option>
        </select>
      </div>
    </div>

    <div className="order-content">
      <div className="customer-section">
        <div className="customer-details">
          <h5>Customer Information</h5>
          <div className="customer-grid">
            <div className="info-group">
              <span className="info-label">Name</span>
              <span className="info-value">
                {order.customerDetails.firstName} {order.customerDetails.lastName}
              </span>
            </div>
            <div className="info-group">
              <span className="info-label">Phone</span>
              <span className="info-value">{order.customerDetails.mobile}</span>
            </div>
            <div className="info-group">
              <span className="info-label">Email</span>
              <span className="info-value">{order.customerDetails.email}</span>
            </div>
          </div>
        </div>

        <div className="payment-details">
          <h5>Payment Details</h5>
          <div className="payment-grid">
            <div className="payment-item">
              <span className="payment-label">Product Price</span>
              <span className="payment-value">₹{order.paymentDetails.productPrice}</span>
            </div>
            <div className="payment-item">
              <span className="payment-label">Security Deposit</span>
              <span className="payment-value">₹{order.paymentDetails.securityDeposit}</span>
            </div>
            <div className="payment-item total">
              <span className="payment-label">Total Amount</span>
              <span className="payment-value">₹{order.paymentDetails.totalAmount}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="products-section">
        <h3>Ordered Products</h3>
        <div className="products-container">
          {order.products.map((product, index) => (
            <OrderProductCard key={index} product={product} />
          ))}
        </div>
      </div>
    </div>

    {order.notification && (
      <div className={`notification ${order.notification.startsWith("Updated") ? "success" : "error"}`}>
        {order.notification}
      </div>
    )}
  </div>
);

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState("newest");
  const [filters, setFilters] = useState({
    orderId: "",
    phone: "",
    customerName: ""
  });

  const fetchOrders = async () => {
    try {
      const response = await axios.get("/api/orders");
      const sortedOrders = response.data.map((order) => ({
        ...order,
        notification: null,
        updatedAt: new Date(),
      }));
      setOrders(sortedOrders);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch orders. Please try again later.");
      setLoading(false);
    }
  };

  const updateDeliveryStatus = async (orderId, status) => {
    try {
      await axios.put(`/api/orders/${orderId}/delivery-status`, {
        deliveryStatus: status,
      });

      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.orderId === orderId
            ? {
              ...order,
              deliveryStatus: status,
              notification: `Updated to '${status}' on ${new Date().toLocaleString()}`,
              updatedAt: new Date(),
            }
            : order
        )
      );
    } catch (err) {
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.orderId === orderId
            ? { ...order, notification: "Failed to update. Please try again.", updatedAt: new Date() }
            : order
        )
      );
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const filteredOrders = orders.filter((order) => {
    const orderIdMatch = order?.orderId?.toLowerCase()?.includes(filters.orderId.toLowerCase());
    const phoneMatch = order?.customerDetails?.mobile?.includes(filters.phone);
    const customerNameMatch =
      `${order?.customerDetails?.firstName} ${order?.customerDetails?.lastName}`
        ?.toLowerCase()
        ?.includes(filters?.customerName?.toLowerCase());

    return (
      (filters.orderId === "" || orderIdMatch) &&
      (filters.phone === "" || phoneMatch) &&
      (filters.customerName === "" || customerNameMatch)
    );
  });

  const sortedOrders = [...filteredOrders].sort((a, b) => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);
    return sortOrder === "newest" ? dateB - dateA : dateA - dateB;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedOrders.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(sortedOrders.length / itemsPerPage);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
    setCurrentPage(1);
  };

  return (
    <>
      <div className="admin-orders">
        <div className="tf-page-title style-2">
          <div className="container-full">
            <div className="heading text-center">
              Order Management</div>
          </div>
        </div>

        <div className="admin-orders-container">
          <AdminHome />

          <div className="orders-content">
            <div className="filters-section">
              <div className="search-group">
                <input
                  type="text"
                  name="orderId"
                  placeholder="Search by Order ID"
                  value={filters.orderId}
                  onChange={handleFilterChange}
                  className="search-input"
                />
                <input
                  type="text"
                  name="phone"
                  placeholder="Search by Phone"
                  value={filters.phone}
                  onChange={handleFilterChange}
                  className="search-input"
                />
                <input
                  type="text"
                  name="customerName"
                  placeholder="Search by Customer Name"
                  value={filters.customerName}
                  onChange={handleFilterChange}
                  className="search-input"
                />
              </div>

              <div className="controls-group">
                <select
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e.target.value)}
                  className="sort-select"
                >
                  <option value="newest">Newest First</option>
                  <option value="oldest">Oldest First</option>
                </select>

                <select
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(Number(e.target.value))}
                  className="items-select"
                >
                  <option value={5}>5 per page</option>
                  <option value={10}>10 per page</option>
                  <option value={20}>20 per page</option>
                  <option value={50}>50 per page</option>
                </select>
              </div>
            </div>

            {loading ? (
              <div className="loading-spinner">Loading orders...</div>
            ) : error ? (
              <div className="error-message">{error}</div>
            ) : (
              <div className="orders-list">
                {currentItems.map((order) => (
                  <OrderCard
                    key={order.orderId}
                    order={order}
                    updateDeliveryStatus={updateDeliveryStatus}
                  />
                ))}
              </div>
            )}

            {!loading && !error && totalPages > 1 && (
              <div className="pagination">
                <button
                  onClick={() => setCurrentPage(prev => prev - 1)}
                  disabled={currentPage === 1}
                  className="pagination-button"
                >
                  Previous
                </button>

                <div className="page-numbers">
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index + 1}
                      onClick={() => setCurrentPage(index + 1)}
                      className={`page-number ${currentPage === index + 1 ? 'active' : ''}`}
                    >
                      {index + 1}
                    </button>
                  ))}
                </div>

                <button
                  onClick={() => setCurrentPage(prev => prev + 1)}
                  disabled={currentPage === totalPages}
                  className="pagination-button"
                >
                  Next
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="btn-sidebar-account">
        <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
          <BsMenuButtonWideFill />
        </button>
      </div>

      <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
        <div className="canvas-wrapper">
          <header className="canvas-header">
            <span className="title">SIDEBAR ACCOUNT</span>
            {/* <SideNavbaBarDashboard /> */}
            <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
          </header>

          <div className="canvas-body sidebar-mobile-append"> </div>
        </div>
      </div>

    </>
  );
};

export default AdminOrders;